<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Đánh giá người {{type == 1 ? 'bán' : 'mua'}}</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<!--<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">-->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Người mua
					</label>
					<cbs-input type="text" v-model="buyer_name" class="w-full" readOnly/>
				</div>
				<div class="mb-5">
					<vs-row class="mb-1">
						<vs-col vs-w="4">
							<label class="text-solid-gray-1">Đánh giá người {{type == 1 ? 'bán' : 'mua'}}:</label>
						</vs-col>
						<vs-col vs-w="8">
							<div class="flex">
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(rating, 1) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(1)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(rating, 2) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(2)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(rating, 3) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(3)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(rating, 4) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(4)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(rating, 5) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(5)">star_rate</i>
							</div>
						</vs-col>
					</vs-row>
				</div>
				<div class="mb-5 mt-5">
					<label for class="text-base vs-input--label">
						Bình luận
					</label>
					<cbs-input type="text" v-model="rating_note" class="w-full" name="rating_note" :data-vv-as="'Bình luận'" :placeholder="`${$t('Input')} ${'Bình luận'}`" />
				</div>
			</div>
		</div>
		<!--</PerfectScrollbar>-->

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Lưu lại</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";

let latPos = 0, lngPos = 0;

export default {
	name: "ShippingForm",
	components: { vSelect, CbsDatePicker },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			type: 1,
			id: null,
			matchId: null,
			buyer_name: null,
			rating: null,
			rating_note: null,
			reRating: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() <= Date.now();
				}
			}
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			// try {
			// 	if (navigator.geolocation) {
			// 		navigator.geolocation.getCurrentPosition(position => {
			// 			console.log('position: ', position);
			// 			if (position.coords) {
			// 				latPos = position.coords.latitude;
			// 				lngPos = position.coords.longitude;
			// 				console.log(latPos, lngPos);
			// 			}
			// 		});
			// 	}
			// } catch (exx) {
			// 	console.log(exx.message);
			// }
			
			const { id , matchId, buyer_name, rating, rating_note, type } = this.data;
			if (id) {
				this.id = id;
			} else {
				this.id = null;
			}
			if (type) {
				this.type = type;
			} else {
				this.type = null;
			}
			if (matchId) {
				this.matchId = matchId;
			} else {
				this.matchId = null;
			}
			if (buyer_name) {
				this.buyer_name = buyer_name;
			} else {
				this.buyer_name = null;
			}
			if (rating) {
				this.rating = rating;
			} else {
				this.rating = null;
			}
			this.reRating = this.rating;
			if (rating_note) {
				this.rating_note = rating_note;
			} else {
				this.rating_note = null;
			}

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		this.getSuppliers();
		
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_view = false, shipping_can_rating = false } = permissions;
			if (shipping_can_view) {
				this.canView = true;
			}
			if (shipping_can_rating) {
				this.canRating = true;
			}
			this.userToken = token;
		}
	},
	methods: {

		changeReview(num) {
			this.rating = num;
		},
		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						id: this.id,
						rating_note: this.rating_note,
						rating: this.rating,
						re_rating: this.reRating
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			// if (this.supplier == 0) {
			// 	this.getSuppliers();
			// }
			// if (!this.id) {
			// 	this.initValues();
			// }
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Lưu thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/ratingBuyer", dataObj);
				this.reRating = dataObj.rating;
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log(error);
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>
